module.exports = __webpack_public_path__ + "media/images/edad-bg-be4f035dccad81dff8c8401eefe4dab0.jpg";